import { useEffect } from 'react';
export const useEscapeHandler = ({ shouldListen, handleEscape }) => {
    useEffect(() => {
        const escapeHandler = ({ code }) => {
            if (code === 'Escape') {
                handleEscape();
            }
        };
        const addEscapeListener = () => {
            document.addEventListener('keydown', escapeHandler);
        };
        const removeEscapeListener = () => {
            document.removeEventListener('keydown', escapeHandler);
        };
        if (shouldListen) {
            addEscapeListener();
        }
        else {
            removeEscapeListener();
        }
        return () => {
            removeEscapeListener();
        };
    }, [shouldListen, handleEscape]);
};
